var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body" },
    [
      _c("page-banner", _vm._b({}, "page-banner", _vm.page.banner, false)),
      _c(
        "page-limiter",
        [
          _vm.crumbs && _vm.crumbs.length
            ? _c("breadcrumbs", { attrs: { crumbs: _vm.crumbs } })
            : _vm._e(),
          _c("h1", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.page.title))
          ]),
          _c("div", { staticClass: "contacts-box" }, [
            _c("div", { staticClass: "contacts__main contacts__city" }, [
              _c("div", {
                staticClass: "contacts__map",
                staticStyle: { width: "100%", height: "400px" },
                attrs: { id: "map" }
              })
            ])
          ]),
          _c("div", { staticClass: "contacts-box contact-flexbox" }, [
            _c(
              "div",
              { staticClass: "main-contacts contacts" },
              [
                _c("h2", { staticClass: "contacts-box__title" }, [
                  _vm._v(_vm._s(_vm.page.main.title))
                ]),
                _vm._l(_vm.page.main.list, function(item) {
                  return _c(
                    "div",
                    { staticClass: "contacts-row" },
                    [
                      item.title
                        ? _c("h3", {
                            domProps: { innerHTML: _vm._s(item.title) }
                          })
                        : _vm._e(),
                      item.address && item.title
                        ? _c("p", {
                            domProps: { innerHTML: _vm._s(item.address) }
                          })
                        : _vm._e(),
                      item.phone && item.title
                        ? _c("p", [
                            _c("a", {
                              staticClass: "contacts-box__list-link",
                              attrs: { href: item.phone_link },
                              domProps: { innerHTML: _vm._s(item.phone) }
                            })
                          ])
                        : _vm._e(),
                      item.email && item.title
                        ? _c("p", [
                            _vm._v("e-mail: "),
                            _c("a", {
                              staticClass: "contacts-box__list-link",
                              attrs: { href: item.email_link },
                              domProps: { innerHTML: _vm._s(item.email) }
                            })
                          ])
                        : _vm._e(),
                      _vm._l(item.elements, function(element) {
                        return item.title
                          ? _c("div", [
                              element.address
                                ? _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(element.address)
                                    }
                                  })
                                : _vm._e(),
                              element.phone
                                ? _c("p", [
                                    _c("a", {
                                      staticClass: "contacts-box__list-link",
                                      attrs: { href: element.phone_link },
                                      domProps: {
                                        innerHTML: _vm._s(element.phone)
                                      }
                                    })
                                  ])
                                : _vm._e(),
                              element.email
                                ? _c("p", [
                                    _vm._v("e-mail: "),
                                    _c("a", {
                                      staticClass: "contacts-box__list-link",
                                      attrs: { href: element.email_link },
                                      domProps: {
                                        innerHTML: _vm._s(element.email)
                                      }
                                    })
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                }),
                _vm.lang === "en"
                  ? _c("div", { staticClass: "contacts-row" }, [
                      _c("h3", [_vm._v("Export Department")]),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "contacts-box__list-link",
                            attrs: { href: "tel:+79885704861" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t+7 988 570 48 61\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ]),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "contacts-box__list-link",
                            attrs: { href: "tel:+79885100163" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t+7 988 510 01 63\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm.feedback
              ? _c(
                  "div",
                  { staticClass: "contacts-box__form" },
                  [
                    _c("h2", { staticClass: "contacts-box__title" }, [
                      _vm._v(_vm._s(_vm.feedback.title))
                    ]),
                    _c("feedback-form", {
                      staticClass: "contacts-box__feedback",
                      attrs: {
                        content: _vm.feedback,
                        action: "/form/feedback",
                        ya_metrica_goal: "contacts_request"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "contacts-box" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2abef288", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abef288","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageContacts.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2abef288","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageContacts.vue
// module chunks = 0